import React from "react";

function TableSkeletonLoader(props) {
  return (
    <div>
      <div className="table-skeleton-wrapper">
        <div className="container">
          <section className="card">
            <div className="card-detail first">
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
            </div>
          </section>
        </div>
        <div className="container">
          <section className="card">
            <div className="card-detail">
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
            </div>
          </section>
        </div>
        <div className="container">
          <section className="card">
            <div className="card-detail">
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
              <h3 className="card-title loading" />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TableSkeletonLoader;
